import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Layout from "../../../components/layout";
import PiecesStockList from "../../../components/stock/PiecesStockList";
import { useAppSelector } from "../../../app/hooks";
import { getLoggingUser } from "../../../features/loggingUser/loggingUserSlice";
import { getSelectedBranch } from "../../../features/settings/settingsSlice";
import { useCanAccess } from "../../../hooks/useCanAccess";
import { t } from "../../../locales";
import { route } from "../../../static/route";

const StockPiecesPage = () => {
  const navigate = useNavigate();
  const canAccess = useCanAccess();
  const loggingUser = useAppSelector(getLoggingUser);
  const selectedBranch = useAppSelector(getSelectedBranch);

  useEffect(() => {
    if (loggingUser?.permissions && selectedBranch && !canAccess("pieces-stock")) {
      navigate(route.dashboard);
    }
  }, [loggingUser, selectedBranch]);

  return (
    <Layout>
      <div className="px-6 py-6">
        <nav className="text-sm font-semibold text-gray-500 mb-4">
          <Link to={route.dashboard} className="text-brand-dark hover:underline">
            {t.stock.breadcrumbHome}
          </Link>
          <span className="mx-2">&rsaquo;</span>
          <span className="text-gray-500">{t.stock.navPieces}</span>
        </nav>
        <h1 className="text-2xl font-bold text-brand-dark mb-6">
          {t.stock.piecesPageTitle}
        </h1>
        <PiecesStockList />
      </div>
    </Layout>
  );
};

export default StockPiecesPage;
